import React from 'react';

import styled from '@emotion/styled';

import { ExternalLink } from '../../components/Link/Link';
import { NavData } from '../NavData';

const Nav = () => {
  return (
    <Container>
      {NavData.map((item, index) => (
        <ExternalLink to={item.link} key={index}>
          <LinkLabel>{item.title}</LinkLabel>
        </ExternalLink>
      ))}
    </Container>
  );
};

export default Nav;

const Container = styled.div`
  display: flex;
  gap: 2.5rem;
  /* outline: 2px solid green; */

  @media (max-width: 480px) {
    display: none;
  }
`;

const LinkLabel = styled.p`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text6};
`;
